import API, { APIResponse } from '../../../lib/commons/api'
import { UserBasic } from '../../../domain/value-object/UserBasicVO'
import { WbsItemStatus } from '../../../domain/entity/WbsItemEntity'

const BASE_PATH = '/api/v1/projects/wbs_item_sub_statuses'

// WBSアイテム(成果物・タスク・チケット)のサブステータス1件。
// isPreset=true はプリセットとして初期投入されたものかどうかの記録で、更新・削除の可否は制御しない。
export interface WbsItemSubStatusResponse {
  value: string
  name: string
  uuid: string
  linkedStatus: WbsItemStatus
  isPreset?: boolean
  // WBSアイテムに設定済みかどうか。使用中のものは削除できない(参照先が失われるため)。
  isUsed?: boolean
  // 表示順(0始まり)。プリセット・カスタムを問わず並べ替え対象。
  displayOrder: number
  // 更新履歴(監査)列。revision は更新回数(例 "0.0.3")。
  revision?: string
  createdAt?: number
  createdBy?: UserBasic
  updatedAt?: number
  updatedBy?: UserBasic
}

interface WbsItemSubStatusDeltaRequest {
  wbsItemType: string
  added?: {
    name: string
    linkedStatus: WbsItemStatus
    displayOrder: number
  }[]
  edited?: {
    uuid: string
    name: string
    linkedStatus: WbsItemStatus
    displayOrder: number
  }[]
  deleted?: { uuid: string }[]
}

// 指定したWBSアイテムタイプに紐づくサブステータス一覧を取得する。
export function fetchWbsItemSubStatuses(
  wbsItemType: string
): Promise<APIResponse> {
  return API.functional.request('GET', BASE_PATH, { wbsItemType })
}

export function updateWbsItemSubStatuses(
  request: WbsItemSubStatusDeltaRequest
): Promise<APIResponse> {
  return API.functional.request('POST', `${BASE_PATH}/batch`, request)
}
